import React, { Component } from 'react';
import TriggerJsonModel, { ClickTriggerJsonModel, CustomTriggerJsonModel } from '../../../domain/tracker/trigger/TriggerJsonModel';
import FormicaInput from '../../custom/FormicaInput';
import RoleHelper from '../../../RoleHelper';
import AnimatedButton from '../../custom/AnimatedButton';
import { RadioButton, RadioButtonChangeParams } from 'primereact/radiobutton';
import { TrackerTriggerTypeWeb } from '../../../domain/tracker/TrackerTriggerType';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import { RootState } from '../../../redux/store';
import { TrackerState } from '../../../redux/reducers/TrackerReducer';
import { changeTracker } from '../../../redux/actions/TrackerActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import TrackerTypeUtil from '../../../util/TrackerTypeUtil';
import Icon from '../../../icons/Icon';
import FormicaLabel from '../../custom/FormicaLabel';
import TrackerFilterJsonModel from '../../../domain/tracker/filter/TrackerFilterJsonModel';
import TrackerVariable from '../../../domain/tracker/variable/TrackerVariable';
import DataType from '../../../constant/DataType';
import MessageUtil from '../../../util/MessageUtil';
import CustomTriggerComponent from './trigger/CustomTriggerComponent';
import ClickTriggerComponent from './trigger/ClickTriggerComponent';
import _ from 'lodash';
import LanguageUtil from '../../../util/LanguageUtil';
import TrackerFilterComponent from './TrackerFilterComponent';

class TrackerEventContentComponent extends Component<Props, State> {
  public state: State = new State();

  public render() {
    const {
      tracker: { tracker },
    } = this.props;
    const { trigger, newFilter, selectedFieldDataType } = this.state;
    const fieldOptions = tracker.variables.map((variable) => ({
      label: variable.name,
      value: variable.name,
      dataType: variable.properties?.dataType || DataType.STRING,
    }));
    return (
      <div className={'flex flex-col h-full w-full'}>
        <div className={'border-b'}>
          <span className={'text-f-black-2 font-semibold'}>{LanguageUtil.get({ id: 'common.label.type', defaultMessage: 'Type' })}</span>
          <div className={'max-h-[500px] overflow-y-scroll'}>
            {TrackerTypeUtil.getEventTypeOptions(tracker.platform).map((data, index) => {
              return (
                <div className={'flex items-center gap-x-2 py-2'} key={index}>
                  <RadioButton
                    inputId={data.value.name}
                    name={data.label}
                    value={data.value}
                    onChange={this.onChangeType}
                    checked={trigger.type == data.value.name}
                  />
                  <div className={'w-7 h-7 bg-[#EFF2FE] rounded-full flex items-center justify-center'}>
                    <Icon icon={data.value.icon || 'tracker-appstatechange'} size={tracker.platform == 'MOBILE' ? 16 : 18} color={'#728EFF'} />
                  </div>
                  <div className={'flex flex-col'}>
                    <span className={'text-f-black-2 text-[13px]'}>{this.formatEnumLabel(data.label)}</span>
                    <span className={'text-f-black-3 text-[10px]'}>Description</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className={'border-b py-5'}>
          <div className={'flex flex-col gap-y-1'}>
            <FormicaLabel label={LanguageUtil.get({ id: 'common.label.name', defaultMessage: 'Name' })} />
            <FormicaInput
              onChange={this.onChangeName}
              value={trigger.name}
              name={'name'}
              label={'Name'}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.name', defaultMessage: 'Name' })}
              type={'text'}
              disabled={!RoleHelper.canEdit('Tracker')}
            />
          </div>
        </div>
        <div className={'border-b py-5'}>
          <div className={'flex flex-col gap-y-1'}>
            <FormicaLabel label={LanguageUtil.get({ id: 'common.label.description', defaultMessage: 'Description' })} />
            <FormicaInput
              value={trigger.description}
              name={'Description'}
              onChange={this.onChangeDescription}
              type={'text'}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.description', defaultMessage: 'Description' })}
              disabled={!RoleHelper.canEdit('Tracker')}
            />
          </div>
        </div>
        {this.getEventFields()}
        <TrackerFilterComponent
          fieldOptions={fieldOptions}
          filters={trigger.filters || []}
          newFilter={newFilter}
          selectedFieldDataType={selectedFieldDataType}
          onAddFilter={this.addFilter}
          onUpdateFilter={this.updateFilter}
          onUpdateNewFilter={this.updateNewFilter}
          onRemoveFilter={this.removeFilter}
          onSelectedFieldChange={(field, dataType) => this.setState({ selectedFieldDataType: dataType })}
        />
        <div className={'py-5 flex gap-x-4 justify-end'}>
          <AnimatedButton
            text={LanguageUtil.get({ id: 'common.button.cancel', defaultMessage: 'Cancel' })}
            customType={'secondary'}
            customSize={'sm'}
            icon={'multiplier'}
            onClick={this.onHide}
            disabled={!RoleHelper.canEdit('Tracker')}
          />
          <AnimatedButton
            text={LanguageUtil.get({ id: 'common.button.apply', defaultMessage: 'Apply' })}
            customType={'primary'}
            customSize={'sm'}
            icon={'add'}
            onClick={this.apply}
            disabled={!RoleHelper.canEdit('Tracker')}
          />
        </div>
      </div>
    );
  }

  public componentDidMount() {
    const { selectedData } = this.props;
    if (selectedData) {
      this.setState({ trigger: _.cloneDeep(selectedData) });
    }
  }

  public componentDidUpdate(prevProps: Props) {
    const { selectedData, visible } = this.props;
    if ((selectedData && selectedData !== prevProps.selectedData) || (visible && !prevProps.visible)) {
      this.setState({ trigger: _.cloneDeep(selectedData) });
    }
  }

  private formatEnumLabel(label: string): string {
    const formattedLabel = label.toLowerCase().replace(/_/g, ' ');
    return formattedLabel.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  private onChangeName = (e: React.FormEvent<HTMLInputElement>) => {
    const { trigger } = this.state;
    trigger.name = e.currentTarget.value;
    this.setState({ trigger });
  };

  private onChangeDescription = (e: React.FormEvent<HTMLInputElement>) => {
    const { trigger } = this.state;
    trigger.description = e.currentTarget.value;
    this.setState({ trigger });
  };

  private onChangeType = (e: RadioButtonChangeParams) => {
    const { trigger } = this.state;
    trigger.type = e.value.name;
    this.setState({ trigger });
  };

  private addFilter = () => {
    const { trigger, newFilter } = this.state;
    trigger.filters.push(newFilter);
    this.setState({
      trigger,
      newFilter: { field: '', operator: undefined, value: '' },
    });
  };

  private updateFilter = (index: number, key: keyof TrackerFilterJsonModel, value: any) => {
    const { trigger } = this.state;
    trigger.filters[index][key] = value;
    this.setState({ trigger });
  };

  private updateNewFilter = (key: keyof TrackerFilterJsonModel, value: any) => {
    const newFilter = { ...this.state.newFilter, [key]: value };
    this.setState({ newFilter });
  };

  private removeFilter = (index: number) => {
    const { trigger } = this.state;
    trigger.filters.splice(index, 1);
    this.setState({ trigger });
  };

  private apply = () => {
    const {
      setSelectedData,
      selectedData,
      tracker: { tracker },
    } = this.props;
    const { trigger } = this.state;
    if (trigger.name == undefined || trigger.name == '') {
      MessageUtil.error({
        summary: 'Tracker',
        detail: <div>Name is required.</div>,
      });
      return;
    }
    if (trigger.name != selectedData?.name && tracker.triggers.some((t) => t.name == trigger.name)) {
      return MessageUtil.error({
        summary: 'Tracker',
        detail: <div>Trigger name already used.</div>,
      });
    }
    setSelectedData(trigger);
    this.setState({ selectedFieldDataType: undefined, newFilter: { field: '', operator: undefined, value: '' } });
    MessageUtil.success({
      summary: 'Tracker',
      detail: <div>Variable updated.</div>,
    });
  };

  private getEventFields = () => {
    const {
      tracker: { tracker },
    } = this.props;
    const { trigger } = this.state;
    if (tracker.platform == 'MOBILE') return;
    switch (trigger.type) {
      case TrackerTriggerTypeWeb.CLICK:
        return <ClickTriggerComponent trigger={trigger as ClickTriggerJsonModel} onChange={(trigger: TriggerJsonModel) => this.setState({ trigger })} />;
      case TrackerTriggerTypeWeb.PAGE_VIEW:
        break;
      case TrackerTriggerTypeWeb.CUSTOM:
        return <CustomTriggerComponent trigger={trigger as CustomTriggerJsonModel} onChange={(trigger: TriggerJsonModel) => this.setState({ trigger })} />;
    }
  };

  private onHide = () => {
    const { onHide } = this.props;
    this.setState({
      trigger: { filters: [] } as any,
      selectedFieldDataType: undefined,
      newFilter: { field: '', operator: undefined, value: '' },
    });
    onHide();
  };
}

class State {
  trigger: TriggerJsonModel = { filters: [] } as any;
  newFilter: TrackerFilterJsonModel = { field: '', operator: undefined, value: '' };
  selectedFieldDataType: DataType | undefined;
}

interface Props extends FormicaProps, ReduxProps {
  selectedData: TriggerJsonModel | undefined;
  setSelectedData: (data: TriggerJsonModel) => void;
  onHide: () => void;
  visible: boolean;
}

const mapStateToProps = (state: RootState) => ({
  tracker: state.tracker as TrackerState,
});

const mapDispatchToProps = {
  changeTracker,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(TrackerEventContentComponent));
